// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@awc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { informationStyles } from "@awc/Overrides/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { styledBoxStyle } from "@awc/XDL/Components/Common/Box";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

informationStyles.informationGridItem = { width: [12, 12, 12, 6, 6] };

informationStyles.invoiceInformationGridContainer = {
    gap: 0,
    css: css`
        ${styledBoxStyle}
        padding:16px;
    `,
};
informationStyles.informationGridContainer = {
    gap: 0,
};

informationStyles.leftGridItem = {
    width: [12, 6, 6, 12, 12],
    css: css`
        ${xScreen("lte", "sm")} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

informationStyles.headingAndTextStyles = {
    ...xOrderInformationStyles.headingAndTextStyles,
};

informationStyles.columnHeadingAndTextStyles = {
    ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles, {
        wrapper: {
            css: css`
                flex-direction: column;
                gap: 8px;
            `,
        },
        heading: {
            css: css`
                &:after {
                    content: none;
                }
            `,
        },
        text: {
            color: "text",
            css: css`
                font-size: ${fontConfig.fontSize.singleLineRegular}px;
            `,
        },
    }),
};
informationStyles.statusGridItem =
    informationStyles.invoiceDateGridItem =
    informationStyles.termsGridItem =
    informationStyles.poNumberGridItem =
    informationStyles.salespersonGridItem =
    informationStyles.dueDateGridItem =
    informationStyles.vatNumberGridItem =
        {
            width: 12,
        };

informationStyles.shippingMethodGridItem = {
    width: 6,
    css: css`
        &&& {
            margin-top: 24px;
        }
    `,
};
informationStyles.billingAddressGridItem = {
    width: 12,
};
informationStyles.shippingAddressGridItem = {
    width: [12, 6, 6, 12, 12],
    css: css`
        &&& {
            margin-top: 24px;
        }
        ${xScreen("lte", "sm")} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

informationStyles.billingAddressStyle = {
    titleText: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 8px;
            `,
        }),
    },
    headerText: {
        css: css`
            display: none;
        `,
    },
    wrapper: {
        css: css`
            margin-bottom: 24px;
        `,
    },
};
informationStyles.shippingAddressStyle = {
    wrapper: {
        css: css`
            margin-bottom: 24px;
        `,
    },
    titleText: {
        css: css`
            display: none;
        `,
    },
    headerText: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 8px;
            `,
        }),
    },
};
